import {mapGetters} from 'vuex';

const isSSR = typeof window === 'undefined';

export default {
    name: 'hearstLogo',
    data: function() {
        return {
            showLogo: true,
            campaign: '',
            utmSource: '',
            svgfiles: ['darientimes', 'fairfieldcitizenonline', 'milfordmirror', 'milfordmirror', 'newmilfordspectrum', 'sheltonherald', 'theridgefieldpress', 'trumbulltimes', 'westport-news', 'wiltonbulletin', 'ncadvertiser']
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        hearstLogoUrl(){
            return `${this.glb.cdnUrl}vimages/hearst/${this.campaign}${this.svgfiles.includes(this.campaign) ? '.svg' : '.png'}`;
        },
        imgAlt(){
            return `${this.glb.geo.city} ${this.glb.geo.state} available homes for sale on Movoto`;
        }
    },
    created: function() {
        const queryObj = !isSSR && this.$route.query;
        if (queryObj) {
            this.campaign = queryObj.utm_campaign;
            this.utmSource = queryObj.utm_source;
        }
        // if(this.utmSource === 'Hearst'){
        //     setTimeout(() => { this.showLogo = false; }, 5500);
        // }
    }
};
